/*
 * Project: LegalPlace assistant
 * File: src\logic\option_wrapper.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */



import { detectType, OptionType, MULTIPLE, CHILDS, VARS, MULTIPLE_PARENTS, FSIZE, ISCONDITIONAL, HELPER, RENDERER, TYPE, META, OPTIONS, VARIABLES, OPTS, LABEL, SECTIONS, INITIAL_OTIONS, CONTRACT_NAME, ARCHITECTURE } from './lp_map_utils';
import { VariableWrapper } from './variable_wrapper';


export class OptionWrapper {
    id = 0;
    type = OptionType.NONE;
    label = "";
    renderer = "";
    dValue = 0;
    helper = "";
    is_conditional = false;
    parentId = -1;
    // Variables
    variables = []
    children = []
    variables_extracted = {};
    children_extracted = {};
    multiple = {};
    is_multiple = false;
    multiple_max_number = 0;
    multiple_text = "";
    multiple_more_text = "";
    warning = "";

    constructor( obj ) {
        //
        if(!obj)return;
        this.id = obj[META]['id']
            // this.type = this.detectType(obj[META][TYPE]);
        this.loadMetaData( obj );
        this.loadVariables( obj );
        this.loadChildren( obj );
        this.loadMultiple( obj );
    }

    // loading meta data
    loadMetaData( obj ) {
            this.type = detectType(obj[META][TYPE]);

            this.label = obj[META][LABEL];
            this.renderer = obj[META][RENDERER];
            this.dValue = obj[META]['default']; // TODO: check the defautl
            this.helper = obj[META][HELPER];
            this.is_conditional = obj[META][ISCONDITIONAL]
            this.parentId = obj[META]['parent_section']; // To modify "parent_section"
            // NEXT
            if( 'multiple' in obj[META] )
                this.is_multiple = obj[META]['multiple']
            if( 'warning' in obj[META] )
                this.warning = obj[META]['warning']
            if( 'multipletext' in obj[META] )
                this.multiple_text = obj[META]['multipletext']
            if( 'multipleIncrtText' in obj[META] )
                this.multiple_more_text = obj[META]['multipleIncrtText']
            if( 'multipleIncrt' in obj[META] )
                this.multiple_max_number = obj[META]['multipleIncrt']

        }
        // TODO: next section will be a little bit changed, it will contain the NOT LAZY LOAD
    loadVariables( obj ) {
        this.variables = obj[VARS];
    }
    loadChildren( obj ) {
        this.children = obj[CHILDS];
    }
    loadMultiple( obj ) {
        if (MULTIPLE in obj)
            this.multiple = obj[MULTIPLE]
    }
    loadFenyanVariables( vars_ref ) {
        this.variables.forEach((variable, index) => {
            this.variables_extracted[index] = new VariableWrapper( vars_ref[variable] );
        })
    }
}



// WEBPACK FOOTER //
// ./src/logic/option_wrapper.js